function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { ref, computed, defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import { colorStyle, getMessageTitle, getMessageContent, setMessageReadFun, handleDrawerList } from "./index";
import MessageDrawer from "./drawer.vue";
import { Unread } from "@pt/api/message/enum";
import { format } from "date-fns";
export default defineComponent({
    components: {
        MessageDrawer: MessageDrawer
    },
    props: {
        data: {
            type: definePropType(Array),
            required: true
        }
    },
    setup: function setup(props) {
        var drawerVisible = ref(false);
        // 未读消息
        var unread = computed(function() {
            return props.data.some(function(t) {
                return t.status === Unread.Send;
            });
        });
        var handleViewItem = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(item) {
                var flag;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            props.data.map(function(t) {
                                return t.show = false;
                            });
                            if (!(item.status === Unread.Send)) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 4;
                            return setMessageReadFun([
                                {
                                    id: item.msg_id,
                                    seq: item.seq
                                }, 
                            ]);
                        case 4:
                            flag = _ctx.sent;
                            if (flag) {
                                item.status = Unread.Read;
                            }
                        case 6:
                            item.show = true;
                            drawerVisible.value = true;
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleViewItem(item) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleIgnoreAll = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var sendArray, msg_ids, flag;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            sendArray = props.data.filter(function(s) {
                                return s.status === Unread.Send;
                            });
                            msg_ids = sendArray.map(function(x) {
                                return {
                                    id: x.msg_id,
                                    seq: x.seq
                                };
                            });
                            if (!unread.value) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 5;
                            return setMessageReadFun(msg_ids);
                        case 5:
                            flag = _ctx.sent;
                            if (flag) {
                                props.data.map(function(t) {
                                    t.status = Unread.Read;
                                    t.show = false;
                                });
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleIgnoreAll() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleViewAll = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            handleDrawerList(props.data);
                            drawerVisible.value = true;
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleViewAll() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            unread: unread,
            drawerVisible: drawerVisible,
            format: format,
            colorStyle: colorStyle,
            getMessageTitle: getMessageTitle,
            getMessageContent: getMessageContent,
            handleViewItem: handleViewItem,
            handleViewAll: handleViewAll,
            handleIgnoreAll: handleIgnoreAll
        };
    }
});
